const contactForm = {
    ui: {},

    init: function() {
        this.bindUI();
        this.bindEvents();
    },

    bindUI: function bindUI() {
        // this.ui.$particularUser = $('input[value="Professional"]');
        // this.ui.$professionalUser = $('input[value="Private-individual"]');

        this.ui.$particularUser = $("#contact_us_profile_0");
        this.ui.$professionalUser = $("#contact_us_profile_1");
        
        this.ui.$disabledUntilProfilSelected = $(".js-disabled-until-profil-selected");

        this.ui.$contactRequestSelect = $(".js-contactRequestSelect");
        this.ui.$disabledUntilProfilSelected = $(".js-disabled-until-profil-selected");
    },

    bindEvents: function bindEvents() {
        this.ui.$particularUser.on('change', this.showOpacityFull.bind(this));
        this.ui.$particularUser.change();
        this.ui.$professionalUser.on('change', this.showOpacityFull.bind(this));
        this.ui.$professionalUser.change();
    },

    showOpacityFull: function(){
        let isCheckedParticular = this.ui.$particularUser.is(':checked');
        let isCheckedProfessional = this.ui.$professionalUser.is(':checked');

        this.ui.$disabledUntilProfilSelected.removeClass("disabled");

        this.ui.$contactRequestSelect.find("[value='open_account']").addClass("js-hide");
        this.ui.$contactRequestSelect.find("[value='accounting']").addClass("js-hide");
        if(isCheckedProfessional) {
            this.ui.$contactRequestSelect.find("[value='open_account']").removeClass("js-hide");
            this.ui.$contactRequestSelect.find("[value='accounting']").removeClass("js-hide");
            // this.ui.$contactRequestSelect.html('')
            // console.log(window.requestPro_options);
            // for (var i = 0; i < window.requestPro_options.length; i++) {
            //     let $option = $("<option value="+window.requestPro_options[i].value+">"+window.requestPro_options[i].label+"</option>");
            //     this.ui.$contactRequestSelect.append($option);
            // }
        } else if(isCheckedParticular){
            // this.ui.$contactRequestSelect.html('')
            // console.log(window.requestPrivate_options);
            // for (var i = 0; i < window.requestPrivate_options.length; i++) {
            //     let $option = $("<option value="+window.requestPrivate_options[i].value+">"+window.requestPrivate_options[i].label+"</option>");
            //     this.ui.$contactRequestSelect.append($option);
            // }
        };
        this.ui.$contactRequestSelect.change();
    },
};

module.exports = contactForm;